var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"icon":"add","icon-classname":_vm.iconClassname,"classname":_vm.classname,"tooltip-text":_vm.tooltipText},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }